import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { EnvService } from 'src/app/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {

  user;
  constructor(public environment: EnvService) {
     this.setUpAmplitudeOptions();
     }

  setUpAmplitudeOptions() {
    const options = {
      trackingOptions: {
        city: true,
        country: true,
        carrier: true,
        device_manufacturer: true,
        device_model: true,
        dma: true,
        ip_address: true,
        language: true,
        os_name: true,
        os_version: true,
        region: true,
        includeGclid: true,
        includeUtm: true,
        includeReferrer: true,
      },
    }
    amplitude.init(this.environment.ampKey);
    amplitude.init(this.environment.ampKey, null, options);
  }

  setAmplitudeEvent(eventName: string): void {
    this.user = JSON.parse(localStorage.getItem("user"));
    let currentUserLicense;
    if(this.user?.license_type){
       currentUserLicense = this.user.license_type == 'TRIAL' ? 'Trial':'Paid';
       amplitude.logEvent(`${eventName} - ${currentUserLicense}`, {url: window.location.href});
    }
  }
}
